import alertify from "alertifyjs";

export const processSvg = (fabric, svgUrl, callback) =>{

    fabric.loadSVGFromURL(svgUrl,(objects)=>{
    if(!objects || !objects.length){
      alertify.error('SVG image not found')
      callback();
      return;
    }

    let garment = objects.find(obj => obj.id === 'garment');

    if(!garment){
      garment = objects.find(obj => !!obj['xlink:href']);
    }

    let posFrame1 = objects.find(obj => obj.id === 'posFrame1');
    let posFrame2 = objects.find(obj => obj.id === 'posFrame2');

    if(!posFrame1 && !posFrame2){
      posFrame1 = objects.find(obj => obj.id === 'posFrame');
    }

      const image = {
        data: garment['xlink:href'],
        width: garment.width || garment.viewBoxWidth,
        height: garment.height || garment.viewBoxHeight,
      }

    const frame1 = posFrame1 ? {
        width: posFrame1.width*(garment.width || garment.viewBoxWidth)/garment.viewBoxWidth,
        height: posFrame1.height*(garment.height || garment.viewBoxHeight)/garment.viewBoxHeight,
        top: ((garment.height || garment.viewBoxHeight) / garment.viewBoxHeight) * posFrame1.top,
        left: ((garment.width || garment.viewBoxWidth) / garment.viewBoxWidth) * posFrame1.left,
        strokeDashArray: posFrame1.strokeDashArray,
        stroke: posFrame1.stroke,
        strokeWidth: posFrame1.strokeWidth,
        strokeMiterLimit: posFrame1.strokeMiterLimit
    } : {}

    const frame2 = posFrame2? {
        width: posFrame2.width*(garment.width || garment.viewBoxWidth)/garment.viewBoxWidth,
        height: posFrame2.height*(garment.height || garment.viewBoxHeight)/garment.viewBoxHeight,
        top: ((garment.height || garment.viewBoxHeight) / garment.viewBoxHeight) * posFrame2.top,
        left: ((garment.width || garment.viewBoxWidth) / garment.viewBoxWidth) * posFrame2.left,
        strokeDashArray: posFrame2.strokeDashArray,
        stroke: posFrame2.stroke,
        strokeWidth: posFrame2.strokeWidth,
        strokeMiterLimit: posFrame2.strokeMiterLimit
    }:{}

      // let shadows = [shadow_1, shadow_2, shadow_3, shadow_4]

      const shadows = objects.filter(obj=>obj.id.toLowerCase().startsWith('shadow'));

    const shadowImages = shadows.map((shadow) => {
      const adjY = (garment.top - shadow.top)
      const adjX = (garment.left - shadow.left)

      return {
        data: shadow['xlink:href'],
        width:  shadow.width,
        height:  shadow.height,
        left: ((garment.width || garment.viewBoxWidth)  / garment.viewBoxWidth) * shadow.left, //- adjX,
        top: ((garment.height || garment.viewBoxHeight) / garment.viewBoxHeight) * shadow.top //- adjY,
      }
    })

      callback(image, frame1, frame2,shadowImages)

    },null,{crossOrigin:'Anonymous'})
  }
